/*
 *
 * Options reducer
 *
 */

import { fromJS, Map } from 'immutable';
import conflictResolver from './reducers/conflictResolver';
import flagChanges from './reducers/flagChanges';
import inputReducer from './reducers/input';
import loadingReducer from './reducers/loading';
import optionsReducer from './reducers/options';
import revertToLast from './reducers/revertToLast';
import wallPanelMatchWorktopReducer from './reducers/wallPanelMatchWorktop';
import kitchenIslandReducer from './reducers/kitchenIsland';
import planReducer, { planInitialState } from './reducers/plan';

export const initialState = fromJS({
  options: {
    materials: [],
    measurements: {},
    shapes: [],
  },
  plan: planInitialState,
  loading: true,
  planLoading: false,
  loaded: { language: null, country: null },
  shapeFields: {},
  overhangFields: {},
  kitchenIslandOverhangFields: {},
  shapesFlipped: {},
  kitchenIslandFlipped: {},
  planName: null,
  planCode: null,
  previous: {
    plan: null,
    shapesFlipped: null,
    kitchenIslandFlipped: null,
    planCode: null,
    shapeFields: null,
  },
});

export default function cwcalcDomainReducer(state = initialState, action, fullState = Map()) {
  // Order matters!!
  return [
    optionsReducer,
    loadingReducer,
    revertToLast,
    planReducer,
    kitchenIslandReducer,
    wallPanelMatchWorktopReducer,
    conflictResolver,
    inputReducer,
    flagChanges,
  ].reduce((reducedState, reducer) => reducer(reducedState, action, fullState), state);
}
